import React, { useEffect, useState } from "react";
import "./Dragger.css";
import { Button, message, Upload } from "antd";
import { useTranslation } from "react-i18next";
import { DeleteFilled, UploadOutlined } from "@ant-design/icons";
import Loading from "../Loading/Loading";
import { isAuthenticated } from "../Auth/auth";
const { Dragger } = Upload;

const DragUpload = ({ updateFiles, value, noMultiple, accept }) => {
  const { t } = useTranslation("dashboard");
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const props = {
    name: "file",
    multiple: true,
    action: `${process.env.REACT_APP_BACKEND_URL}/files/upload`,
    onChange(info) {
      setUploading(true);
      const { status } = info.file;
      let trimmedFilesArray = info.fileList?.map(f => f?.response);
      if (status !== "uploading") {
        setUploading(false);
      }
      if (status === "done") {
        if (noMultiple) {
          updateFiles([trimmedFilesArray[0]]);
          setFileList([trimmedFilesArray[0]]);
        } else {
          if (fileList?.length > 0) {
            updateFiles([...fileList, trimmedFilesArray[trimmedFilesArray?.length - 1]]);
            setFileList([...fileList, trimmedFilesArray[trimmedFilesArray?.length - 1]]);
          }
          // else {
          //   updateFiles([trimmedFilesArray[0]]);
          //   setFileList([trimmedFilesArray[0]]);
          // }
        }
        message.success(t("{{name}} file uploaded successfully.", { name: info.file.name }));
      } else if (status === "error") {
        message.error(t("{{name}} file upload failed.", { name: info.file.name }));
      }
    },
    onDrop(e) {}
  };

  useEffect(() => {
    if (value && Array.isArray(value)) {
      setFileList(value);
    } else {
      setFileList([]);
    }
  }, [value]);

  const handleDelete = index => {
    const updatedFiles = fileList.filter((file, i) => i !== index);
    setFileList(updatedFiles);
    updateFiles(updatedFiles);
  };

  return (
    <div className="drag-upload">
      <Dragger
        accept={accept === "image" ? "image/*" : ""}
        headers={{
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }}
        maxCount={noMultiple ? 1 : 10}
        {...props}
        className="drag-upload__zone"
        showUploadList={false}
        previewFile={false}
      >
        <div className="drag-upload__prompt">
          <UploadOutlined className="drag-upload__icon" />
          <div>
            <span className="drag-upload__cta">{t("Click to upload pictures")}</span>{" "}
            <span className="drag-upload__hint">{t("or drag and drop")}</span>
          </div>
        </div>
      </Dragger>
      {((Array.isArray(fileList) && fileList.length > 0) || uploading) && (
        <div className="drag-upload__files">
          {Array.isArray(fileList) &&
            fileList.map((file, index) => (
              <div key={index} className="drag-upload__thumb">
                <img src={file?.url} alt={file?.name} width={72} height={72} />
                <Button
                  size="small"
                  shape="circle"
                  danger
                  className="drag-upload__remove"
                  icon={<DeleteFilled />}
                  aria-label={t("Remove")}
                  onClick={() => handleDelete(index)}
                />
              </div>
            ))}
          {uploading && (
            <div className="drag-upload__thumb drag-upload__thumb--loading">
              <Loading />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default DragUpload;
